import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    editing: false,

    // Product
    saveNewProduct: false,
    saveEditProduct: false,
    saveNewProductMovements: false,
    saveEditProductMovements: false,
    saveNewPriceList: false,
    saveEditPriceList: false,

    // Client
    saveNewClient: false,
    saveEditClient: false,
    saveEditClientInWholeSystem: false,
    saveNewClientMovements: false,
    saveEditClientMovements: false,

    // Company
    saveNewCompany: false,

    // Supplier
    saveNewSupplier: false,
    saveEditSupplier: false,
    saveNewSupplierMovements: false,
    saveEditSupplierMovements: false,

    // Cash
    saveNewCashRegister: false,
    saveEditCashRegister: false,
    saveNewBankAccounts: false,
    saveEditBankAccounts: false,
    saveNewPOS: false,
    saveEditPOS: false,
    saveCashAccountingSettings: false,
    saveNewCheque: false,
    saveNewLoan: false,
    saveNewCard: false,

    // Sales Settings
    saveSalesSettings: false,
    saveQuickRetailSettings: false,

    // Buys Settings
    saveBuysSettings: false,

    // Sales
    saveAutomaticSales: false,
    saveEditAutomaticSales: false,
    saveQuickRetailSales: false,
    saveEditQuickRetailSales: false,
    saveSales: false,
    saveEditSales: false,
    saveClientPayments: false,
    saveEditClientPayments: false,
    sendEmail: "inactive",

    // Quotations
    saveQuotations: false,
    saveEditQuotations: false,

    // Buys
    saveBuys: false,
    saveEditBuys: false,
    saveSupplierPayments: false,
    saveEditSupplierPayments: false,

    // Settings
    saveBasicType: false,
    saveEditBasicType: false,
    saveAdvancedType: false,
    saveEditAdvancedType: false,
    savePrimerMyData: false,
    saveEmailSMtp: false,

    // Accounting
    saveNewAccountingAccount: false,
    saveEditAccountingAccount: false,
    saveNewAccountingRecord: false,
    saveEditAccountingRecord: false,
    saveAccountingPaymentTypes: false,
    saveNewAccountingClosure: false,

    // Payroll
    saveNewEmployee: false,
    saveEditEmployee: false,
    sendEmployeeQROnSave: false,
    sendEmployeeNewPasswordOnSave: false,
    sendEmployeeChangesToErgani: false,
    saveNewWorkMovement: false,
    saveNewWorkPermit: false,
    saveEditWorkPermit: false,

    // Prescription
    saveNewVisit: false,
    saveActiveVisit: false,

    // Fixed Assets
    saveFixedAssetsSettings: false,
    saveNewFixedAsset: false,
    saveEditFixedAsset: false,
    saveNewFixedAssetMovement: false,
    saveEditFixedAssetMovement: false,
    saveNewFixedAssetRecord: false,
    saveEditFixedAssetRecord: false,

    // Scrolling
    rememberInnerTab: {}, // Will have templateType : tabIndex
    updateInnerTab: -1,

    // Slide Bar
    slideBarToggle: false,
    slideBarOpen: true,

    // For Emron
    emronCompanyInvalid: false,
    canBypassInvalidCompany: false,
    emronCompanyInvalidDays: 0,
    isEmronClient: false,
    emronClientData: null,
    isEmron: false,

    // For Emron Connect
    isEmronConnectFileERP: false,

    primerMyDataToExpireModal: false,
    primerMyDataToExpireModalLink: "",
    primerMyDataExpirationModalMessage: "",
    refreshEditModalData: {
        show: false,
        documentType: "",
        document: null
    },

    showFooterDrawer: false,
    showReleaseNotesModal: false
}

export const ActivitySlice = createSlice({
    name: "Activity",
    initialState,
    reducers: {
        setEditing: (state, {payload}) => {
            state.editing = payload;
        },

        // Product
        setSaveNewProduct: (state, {payload}) => {
            state.saveNewProduct = payload;
        },
        setSaveEditProduct: (state, {payload}) => {
            state.saveEditProduct = payload;
        },
        setSaveNewProductMovements: (state, {payload}) => {
            state.saveNewProductMovements = payload;
        },
        setSaveEditProductMovements: (state, {payload}) => {
            state.saveEditProductMovements = payload;
        },
        setSaveNewPriceList: (state, {payload}) => {
            state.saveNewPriceList = payload;
        },
        setSaveEditPriceList: (state, {payload}) => {
            state.saveEditPriceList = payload;
        },

        // Client
        setSaveNewClient: (state, {payload}) => {
            state.saveNewClient = payload;
        },
        setSaveEditClient: (state, {payload}) => {
            state.saveEditClient = payload;
        },
        setSaveNewClientMovements: (state, {payload}) => {
            state.saveNewClientMovements = payload;
        },
        setSaveEditClientInWholeSystem: (state, {payload}) => {
            state.saveEditClientInWholeSystem = payload;
        },

        // Company
        setSaveNewCompany: (state, {payload}) => {
            state.saveNewCompany = payload;
        },

        // Supplier
        setSaveNewSupplier: (state, {payload}) => {
            state.saveNewSupplier = payload;
        },
        setSaveEditSupplier: (state, {payload}) => {
            state.saveEditSupplier = payload;
        },

        // Cash
        setSaveNewCashRegister: (state, {payload}) => {
            state.saveNewCashRegister = payload;
        },
        setSaveEditCashRegister: (state, {payload}) => {
            state.saveEditCashRegister = payload;
        },
        setSaveNewBankAccounts: (state, {payload}) => {
            state.saveNewBankAccounts = payload;
        },
        setSaveEditBankAccounts: (state, {payload}) => {
            state.saveEditBankAccounts = payload;
        },
        setSaveNewPOS: (state, {payload}) => {
            state.saveNewPOS = payload;
        },
        setSaveEditPOS: (state, {payload}) => {
            state.saveEditPOS = payload;
        },
        setSaveCashAccountingSettings: (state, {payload}) => {
            state.saveCashAccountingSettings = payload;
        },
        setSaveNewCheque: (state, {payload}) => {
            state.saveNewCheque = payload;
        },
        setSaveNewLoan: (state, {payload}) => {
            state.saveNewLoan = payload;
        },
        setSaveNewCard: (state, {payload}) => {
            state.saveNewCard = payload;
        },

        // Sales Settings
        setSaveSalesSettings: (state, {payload}) => {
            state.saveSalesSettings = payload;
        },

        // Buys Settings
        setSaveBuysSettings: (state, {payload}) => {
            state.saveBuysSettings = payload;
        },

        // Sales
        setSaveSales: (state, {payload}) => {
            state.saveSales = payload;
        },
        setSaveEditSales: (state, {payload}) => {
            state.saveEditSales = payload;
        },

        // Quotations
        setSaveQuotations: (state, {payload}) => {
            state.saveQuotations = payload;
        },
        setSaveEditQuotations: (state, {payload}) => {
            state.saveEditQuotations = payload;
        },

        // Primer AI Url
        setSavePrimerAiUrl: (state, {payload}) => {
            state.savePrimerAiUrl = payload;
        },

        setSaveClientPayments: (state, {payload}) => {
            state.saveClientPayments = payload;
        },
        setSaveEditClientPayments: (state, {payload}) => {
            state.saveEditClientPayments = payload;
        },

        // Buys
        setSaveBuys: (state, {payload}) => {
            state.saveBuys = payload;
        },
        setSaveEditBuys: (state, {payload}) => {
            state.saveEditBuys = payload;
        },

        setSaveSupplierPayments: (state, {payload}) => {
            state.saveSupplierPayments = payload;
        },
        setSaveEditSupplierPayments: (state, {payload}) => {
            state.saveEditSupplierPayments = payload;
        },

        // Settings
        setSaveBasicType: (state, {payload}) => {
            state.saveBasicType = payload;
        },
        setSaveEditBasicType: (state, {payload}) => {
            state.saveEditBasicType = payload;
        },
        setSaveAdvancedType: (state, {payload}) => {
            state.saveAdvancedType = payload;
        },
        setSaveEditAdvancedType: (state, {payload}) => {
            state.saveEditAdvancedType = payload;
        },
        setSavePrimerMyData: (state, {payload}) => {
            state.savePrimerMyData = payload;
        },
        setSavePrimerMyDataData: (state, {payload}) => {
            state.savePrimerMyDataData = payload;
        },
        setSaveEmailSmtp: (state, {payload}) => {
            state.saveEmailSMtp = payload;
        },
        setSendEmail: (state, {payload}) => {
            state.sendEmail = payload;
        },

        // Accounting
        setSaveNewAccountingAccount: (state, {payload}) => {
            state.saveNewAccountingAccount = payload;
        },
        setSaveEditAccountingAccount: (state, {payload}) => {
            state.saveEditAccountingAccount = payload;
        },
        setSaveNewAccountingRecord: (state, {payload}) => {
            state.saveNewAccountingRecord = payload;
        },
        setSaveEditAccountingRecord: (state, {payload}) => {
            state.saveEditAccountingRecord = payload;
        },
        setSaveAccountingPaymentTypes: (state, {payload}) => {
            state.saveAccountingPaymentTypes = payload;
        },
        setSaveNewAccountingClosure: (state, {payload}) => {
            state.saveNewAccountingClosure = payload;
        },

        // Payroll
        setSaveNewEmployee: (state, {payload}) => {
            state.saveNewEmployee = payload;
        },
        setSaveEditEmployee: (state, {payload}) => {
            state.saveEditEmployee = payload;
        },
        setSendEmployeeQROnSave: (state, {payload}) => {
            state.sendEmployeeQROnSave = payload;
        },
        setSendEmployeeNewPasswordOnSave: (state, {payload}) => {
            state.sendEmployeeNewPasswordOnSave = payload;
        },
        setSendEmployeeChangesToErgani: (state, {payload}) => {
            state.sendEmployeeChangesToErgani = payload;
        },
        setSaveNewWorkMovement: (state, {payload}) => {
            state.saveNewWorkMovement = payload;
        },
        setSaveNewWorkPermit: (state, {payload}) => {
            state.saveNewWorkPermit = payload;
        },
        setSaveEditWorkPermit: (state, {payload}) => {
            state.saveEditWorkPermit = payload;
        },

        // Prescription
        setSaveNewVisit: (state, {payload}) => {
            state.saveNewVisit = payload;
        },
        setSaveActiveVisit: (state, {payload}) => {
            state.saveActiveVisit = payload;
        },

        // Fixed Assets
        setSaveFixedAssetsSettings: (state, {payload}) => {
            state.saveFixedAssetsSettings = payload;
        },
        setSaveNewFixedAsset: (state, {payload}) => {
            state.saveNewFixedAsset = payload;
        },
        setSaveEditFixedAsset: (state, {payload}) => {
            state.saveEditFixedAsset = payload;
        },
        setSaveNewFixedAssetMovement: (state, {payload}) => {
            state.saveNewFixedAssetMovement = payload;
        },
        setSaveEditFixedAssetMovement: (state, {payload}) => {
            state.saveEditFixedAssetMovement = payload;
        },
        setSaveNewFixedAssetRecord: (state, {payload}) => {
            state.saveNewFixedAssetRecord = payload;
        },
        setSaveEditFixedAssetRecord: (state, {payload}) => {
            state.saveEditFixedAssetRecord = payload;
        },

        setRememberInnerTab: (state, {payload}) => {
            state.rememberInnerTab = {...state.rememberInnerTab, ...payload};
        },
        setRememberInnerTabsForce: (state, {payload}) => {
            state.rememberInnerTab = payload;
        },
        setEmronCompanyInvalid: (state, {payload}) => {
            state.emronCompanyInvalid = payload;
        },
        setCanBypassInvalidCompany: (state, {payload}) => {
            state.canBypassInvalidCompany = payload;
        },
        setEmronCompanyInvalidDays: (state, {payload}) => {
            state.emronCompanyInvalidDays = payload;
        },
        setIsEmronClient: (state, {payload}) => {
            state.isEmronClient = payload;
        },
        setEmronClientData: (state, {payload}) => {
            state.emronClientData = payload;
        },
        setIsEmron: (state, {payload}) => {
            state.isEmron = payload;
        },
        setIsEmronConnectFileERP: (state, {payload}) => {
            state.isEmronConnectFileERP = payload;
        },

        setUpdateInnerTab: (state, {payload}) => {
            state.updateInnerTab = payload;
        },
        setShowPrimerMyDataToExpireModal: (state, {payload}) => {
            state.primerMyDataToExpireModal = payload;
        },
        setPrimerMyDataModalLink: (state, {payload}) => {
            state.primerMyDataToExpireModalLink = payload;
        },
        setPrimerMyDataExpirationModalMessage: (state, {payload}) => {
            state.primerMyDataExpirationModalMessage = payload;
        },
        setRefreshEditModalData: (state, {payload}) => {
            state.refreshEditModalData = payload;
        },
        // Burger & Menu
        setSlideBarToggle: (state, {payload}) => {
            state.slideBarToggle = payload;
        },
        setSlideBarOpen: (state, {payload}) => {
            state.slideBarOpen = payload;
        },
        setShowFooterDrawer: (state, {payload}) => {
            state.showFooterDrawer = payload;
        },
        setShowReleaseNotesModal: (state, {payload}) => {
            state.showReleaseNotesModal = payload;
        }
    },
});

export const {
    // Common
    setEditing,

    // Product
    setSaveEditProduct,
    setSaveNewProduct,
    setSaveNewProductMovements,
    setSaveEditProductMovements,
    setSaveNewPriceList,
    setSaveEditPriceList,

    // Client
    setSaveNewClient,
    setSaveEditClient,
    setSaveEditClientInWholeSystem,
    setSaveNewClientMovements,

    // Company
    setSaveNewCompany,

    // Supplier
    setSaveNewSupplier,
    setSaveEditSupplier,

    // Cash
    setSaveNewCashRegister,
    setSaveEditCashRegister,
    setSaveNewBankAccounts,
    setSaveEditBankAccounts,
    setSaveNewPOS,
    setSaveEditPOS,
    setSaveCashAccountingSettings,
    setSaveNewCheque,
    setSaveNewLoan,
    setSaveNewCard,

    // Sales
    setSaveSalesSettings,
    setSaveSales,
    setSaveEditSales,
    setSaveClientPayments,
    setSaveEditClientPayments,

    // Quotations
    setSaveQuotations,
    setSaveEditQuotations,

    // PrimerAiUrl
    setSavePrimerAiUrl,

    // Buys
    setSaveBuysSettings,
    setSaveBuys,
    setSaveEditBuys,
    setSaveSupplierPayments,
    setSaveEditSupplierPayments,

    // Settings
    setSaveBasicType,
    setSaveEditBasicType,
    setSaveAdvancedType,
    setSaveEditAdvancedType,
    setSavePrimerMyData,
    setSavePrimerMyDataData,
    setSaveEmailSmtp,
    setSendEmail,

    // Accounting
    setSaveNewAccountingAccount,
    setSaveEditAccountingAccount,
    setSaveNewAccountingRecord,
    setSaveEditAccountingRecord,
    setSaveAccountingPaymentTypes,
    setSaveNewAccountingClosure,

    // Payroll
    setSaveNewEmployee,
    setSaveEditEmployee,
    setSendEmployeeQROnSave,
    setSendEmployeeNewPasswordOnSave,
    setSendEmployeeChangesToErgani,
    setSaveNewWorkMovement,
    setSaveNewWorkPermit,
    setSaveEditWorkPermit,

    // Prescription
    setSaveNewVisit,
    setSaveActiveVisit,

    // Fixed Assets
    setSaveFixedAssetsSettings,
    setSaveNewFixedAsset,
    setSaveEditFixedAsset,
    setSaveNewFixedAssetMovement,
    setSaveEditFixedAssetMovement,
    setSaveNewFixedAssetRecord,
    setSaveEditFixedAssetRecord,

    setUpdateInnerTab,
    setRememberInnerTab,
    setRememberInnerTabsForce,

    setEmronCompanyInvalid,
    setCanBypassInvalidCompany,
    setEmronCompanyInvalidDays,
    setIsEmronClient,
    setEmronClientData,
    setIsEmron,

    setIsEmronConnectFileERP,
    setShowPrimerMyDataToExpireModal,
    setPrimerMyDataModalLink,
    setPrimerMyDataExpirationModalMessage,
    setRefreshEditModalData,
    setSlideBarToggle,
    setSlideBarOpen,
    setShowFooterDrawer,
    setShowReleaseNotesModal
} = ActivitySlice.actions;
